// Auth Routes
export const ACCOUNT = "account";
export const SIGNUP_OTP = "signup-otp";
export const EMAIL_VERIFIED = "email-verified";
export const PASSWORD_RESET = "password-reset";
export const FORGOT_PASSWORD = "forgot-password";
export const FORGOT_PASSWORD_SUCCESS = 'forgot-password-success';
export const HEALTH_SIGNUP = "health-signup";
export const HEALTH_SIGNIN = "health-signin";

// Landing-page routes
export const DASHBOARD = "dashboard";
export const JOBS = "jobs";
export const APPLICATION = "your-jobs-applications";
export const UERS_SETTINGS = "settings";
export const VIEW_ALL_POSTED_JOBSS = "dashboard/view-all-posted-jobs";
export const VIEW_ALL_APPLICANTSS = "dashboard/view-all-applicants";
export const MANAGE_POSTED_JOBS = 'manage-posted-jobs';

// Institution Dashboard routes
export const INSTITUTION_DASHBOARD = "dashboard";

// NotFound
export const NOTFOUND = "404";
